module.exports = __webpack_public_path__ + "img/ts20.c1b2a451.png";